export function getFormFieldAccessibilityTarget(element) {
    const selectRoot = element?.closest?.('[js-form-select]');

    if (selectRoot && element.matches('select')) {
        return selectRoot.querySelector('[js-form-select-trigger]') ?? element;
    }

    return element;
}

export function showFormErrorRegion(errorRegion) {
    if (!errorRegion) return;

    errorRegion.hidden = false;
    errorRegion.setAttribute('aria-hidden', 'false');
    errorRegion.setAttribute('role', 'alert');
    errorRegion.setAttribute('aria-live', 'polite');
}

export function hideFormErrorRegion(errorRegion) {
    if (!errorRegion) return;

    errorRegion.hidden = true;
    errorRegion.setAttribute('aria-hidden', 'true');
    errorRegion.removeAttribute('role');
    errorRegion.removeAttribute('aria-live');
}

export class FormErrors {
    constructor(form = null) {
        if (!form) return;
        this.root = form;
    }

    getAccessibilityTarget(element) {
        return getFormFieldAccessibilityTarget(element);
    }

    addErrorDescription(field, errorId) {
        if (!errorId) return;

        const ids = (field.getAttribute('aria-describedby') || '')
            .split(/\s+/)
            .filter(Boolean);

        if (!ids.includes(errorId)) {
            field.setAttribute('aria-describedby', [...ids, errorId].join(' '));
        }
    }

    removeErrorDescription(field, errorId) {
        if (!errorId) return;

        const ids = (field.getAttribute('aria-describedby') || '')
            .split(/\s+/)
            .filter(id => id && id !== errorId);

        if (ids.length) {
            field.setAttribute('aria-describedby', ids.join(' '));
        } else {
            field.removeAttribute('aria-describedby');
        }
    }

    clearErrors(fieldsToCheck = null, withTextClear = false) {
        const fields =
            fieldsToCheck ??
            this.root.querySelectorAll(
                'input:not([type="hidden"])',
                'textarea',
                'select'
            );

        fields.forEach(field => {
            const parent = field?.closest?.('.group');
            if (!field || !parent) return;

            const a11yTarget = this.getAccessibilityTarget(field);
            const errorText = parent.querySelector('[js-error-text]');
            const errorRegion = parent.querySelector('[js-form-error]');

            parent.classList.remove('-error');
            a11yTarget?.removeAttribute('aria-invalid');

            hideFormErrorRegion(errorRegion);
            this.removeErrorDescription(a11yTarget, errorText?.id);

            if (withTextClear && errorText) {
                errorText.textContent = '';
            }
        });
    }

    handleFieldError(element = null, isError = true, message = '') {
        if (!element) return;

        if (typeof element === 'string') {
            element = this.root.querySelector(`[name="${element}"]`);
        }

        const parent = element.closest('.group');
        const a11yTarget = this.getAccessibilityTarget(element);
        parent.classList.remove('-error');
        const errorText = parent.querySelector('[js-error-text]');
        const errorRegion = parent.querySelector('[js-form-error]');
        const errorId = errorText?.id;

        if (isError) {
            errorText.textContent = '';
            showFormErrorRegion(errorRegion);
            parent.classList.add('-error');
            a11yTarget.setAttribute('aria-invalid', 'true');
            this.addErrorDescription(a11yTarget, errorId);
            errorText.textContent = message;
        } else {
            a11yTarget.removeAttribute('aria-invalid');
            parent.classList.remove('-error');
            this.removeErrorDescription(a11yTarget, errorId);
            setTimeout(() => {
                errorText.textContent = '';
                hideFormErrorRegion(errorRegion);
            }, 500);
        }
    }
}
